import React, { Fragment, FunctionComponent, useContext, useEffect, useState } from 'react';

import { Text } from '../../../shared/Text';
import { StepperContent, StepperHeader, StepperSubmit } from '../../../shared/Stepper';
import { useForm } from 'react-hook-form';
import { Input } from '../../../shared/Input';
import { formItems } from '../formItems';
import { InputHolder, InputHolderItem } from '../../../shared/InputHolder';
import { FormContext } from '../../../../store/refinance/RefinanceContext';
import { currencyToNumber, numberToCurrency } from '../../../../utils/formatting';
import { Radio } from '../../../shared/Radio';
import { scrollToTopCalculator } from '../../../../utils/general';

export const Step3: FunctionComponent<{ id: number }> = ({id}) => {
	const {
		register,
		handleSubmit,
		formState: {errors, isValid},
	} = useForm({mode: 'onChange'});

	const [completedText, setCompletedText] = useState('');
	const [isNhg, setNhg] = useState(false);
	const { updateForm, form, nhg, remainingMortgage } = useContext(FormContext);

	useEffect(() => {
		if (nhg && remainingMortgage) {
			setNhg(nhg?.existingBuilding > remainingMortgage.totalResidualDebt);
		}
	}, [nhg, remainingMortgage])


	const onSubmit = (data: any) => {

		data[formItems.step3.costs.administration] = currencyToNumber(data[formItems.step3.costs.administration]);
		data[formItems.step3.costs.taxation] = currencyToNumber(data[formItems.step3.costs.taxation]);
		data[formItems.step3.costs.notary] = currencyToNumber(data[formItems.step3.costs.notary]);
		data[formItems.step3.mortgageWithNhg] = (isNhg) ? data[formItems.step3.mortgageWithNhg] === "true" : false;

		setCompletedText(numberToCurrency((data[formItems.step3.costs.administration] + data[formItems.step3.costs.taxation] + data[formItems.step3.costs.notary]), true));
		updateForm(data);
		scrollToTopCalculator();
	};

	return (
		<Fragment>
				<StepperHeader title="Oversluitkosten" id={id} completedText={completedText}/>
				<StepperContent>
					<Text as="h3">{`De resterende hypotheek is nu ${numberToCurrency(remainingMortgage?.totalResidualDebt, true)}.`}</Text>
					<form onSubmit={handleSubmit(onSubmit)}>
						<InputHolder tooltip={formItems.step3.toolTips.administration}>
							<InputHolderItem isFullWidth={true}>
								<Input
									label="Advies- en bemiddelingskosten*"
									name={formItems.step3.costs.administration}
									id={formItems.step3.costs.administration}
									type="currency"
									hasError={errors[formItems.step3.costs.administration]}
									placeholder="€"
									defaultValue={`€ 3.295`}
									register={register}
									validation={{required: true}}
								/>
								{errors[formItems.step3.costs.administration] && (
									<span className="form__error">Vul de advies- en bemiddelingskosten in</span>
								)}
							</InputHolderItem>
						</InputHolder>
						<InputHolder tooltip={formItems.step3.toolTips.taxation}>
							<InputHolderItem isFullWidth={true}>
								<Input
									label="Taxatiekosten*"
									name={formItems.step3.costs.taxation}
									id={formItems.step3.costs.taxation}
									type="currency"
									hasError={errors[formItems.step3.costs.taxation]}
									placeholder="€"
									defaultValue={`€ 495`}
									register={register}
									validation={{required: true}}
								/>
								{errors[formItems.step3.costs.taxation] && (
									<span className="form__error">Vul de taxatiekosten in</span>
								)}
							</InputHolderItem>
						</InputHolder>
						<InputHolder tooltip={formItems.step3.toolTips.notary}>
							<InputHolderItem isFullWidth={true}>
								<Input
									label="Notariskosten*"
									name={formItems.step3.costs.notary}
									id={formItems.step3.costs.notary}
									type="currency"
									hasError={errors[formItems.step3.costs.notary]}
									placeholder="€"
									defaultValue={`€ 700`}
									register={register}
									validation={{required: true}}
								/>
								{errors[formItems.step3.costs.notary] && (
									<span className="form__error">Vul de notariskosten in</span>
								)}
							</InputHolderItem>
						</InputHolder>
						{isNhg &&
						<InputHolder isFlexWrap={true} tooltip={formItems.step3.toolTips.nhg}>
							<InputHolderItem isFlexBasis={true}>
								<label className="input__label" htmlFor="mortgage.0.mortgageAmountStartFixedInterestRate">
									Hypotheek met NHG?*</label>
							</InputHolderItem>
							<InputHolderItem isSmall={true}>
								<Radio
								label="Ja"
								checked={false}
								name={formItems.step3.mortgageWithNhg}
								id={`${formItems.step3.mortgageWithNhg}-1`}
								defaultValue={'true'}
								register={register}
								/>
							</InputHolderItem>
							<InputHolderItem isSmall={true}>
								<Radio
								label="Nee"
								checked={true}
								name={formItems.step3.mortgageWithNhg}
								id={`${formItems.step3.mortgageWithNhg}-2`}
								defaultValue={'false'}
								register={register}
								/>
							</InputHolderItem>
						</InputHolder>
						}
						<StepperSubmit id={id} isValidated={isValid}/>
					</form>
				</StepperContent>
		</Fragment>
	);
};
